module.exports = {
  /**
   * @type {string}
   * @description 导航栏标题
   */
  // 讯飞大屏登录验证信息
  xfLoginInfo:{
    loginUrl: 'http://eatest.qicp.net/supervise/api/sys/login',
    xfScreenBaseUrl: 'http://eatest.qicp.net/supervise/bigScreenIndex.html?isShowBack=false&token_patch=',
    user1:{
      username: 'dongying',
      password: 'dy123456',  
    }
  },
  // 大屏配置
  dashBoardManager:{
    dashboard1:{
      boxs: ['box1','box2','box3','box4','box5','box6']
    },
    dashboard2:{
      boxs: ['box1','box2','box3','box4','box5']
    },
    dashboard3:{
      boxs: ['box1','box2','box3','box4','box5','box6']
    },
    dashboard4:{
      boxs: ['box1','box2','box3','box4','box5','box6']
    },
    dashboard5:{
      boxs: ['box1','box2','box3','box4','box5','box6']
    }
  }
}
